import React, { useEffect } from "react";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import Hero from "../../components/Home/Hero/Hero";
import About from "../../components/Home/About/About";
import Services from "../../components/Home/services/Services";
import CaseStudies from "../../components/Home/case studies/CaseStudies";
import Message from "../../components/Home/Message/Message";
import Testimonials from "../../components/Home/Testimonials/Testimonials";
import Guide from "../../components/Home/Guide/Guide";
import "./Home.css";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <div className="home_container">
      <Header />
      <Hero />
      <About />
      <Services />
      <CaseStudies />
      <Message />
      <Testimonials />
      <Guide />
      <Footer />
    </div>
  );
}

export default Home;
